/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from "clsx";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useQueryParams } from "../../utils/utils";

export const ITEMS_PER_PAGE = 30;

const UsersListPagination = ({
  pathname,
  total,
}: {
  pathname: string;
  total: number | undefined;
}) => {
  const { page, limit } = useQueryParams();

  const initPagination = {
    page: 1,
    links: ["1", "2", "3"],
  };

  const initItemsPerPage = {
    limit: ITEMS_PER_PAGE,
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const params: any = {};

  //@ts-ignore
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1];
  }

  const [pagination, setPagination] = useState(initPagination);
  const [itemsPerPage, setItemsPerPage] = useState(initItemsPerPage);

  const navigate = useNavigate();

  const updatePage = (page: number) => {
    navigate({
      pathname,
      search: `?${createSearchParams({
        ...params,
        page: page ? `${page}` : "1",
        limit: itemsPerPage.limit || String(ITEMS_PER_PAGE),
      })}`,
    });
  };

  const updateItemsPerPage = (limit: string) => {
    navigate({
      pathname,
      search: `?${createSearchParams({
        page: page ? `${page}` : "1",
        limit: limit || String(ITEMS_PER_PAGE),
      })}`,
    });
  };

  useEffect(() => {
    setItemsPerPage({ ...itemsPerPage, limit: limit || ITEMS_PER_PAGE });
    setPagination({
      ...pagination,
      page: +page || 1,
      links: total
        ? Array(Math.ceil(total / +(limit || ITEMS_PER_PAGE)))
            .fill(null)
            .map((_, i) => `${+i + 1}`)
        : ["1"],
    });
  }, [page, limit, total]);

  return (
    <div className="row">
      {/* <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div> */}
      <div className="col-sm-12 col-md-12 d-flex align-items-center justify-content-center justify-content-md-end">
        <div id="kt_table_users_paginate">
          <ul className="pagination">
            {/* <section
              style={{ display: "flex", alignItems: "center", marginRight: 50 }}
            >
              Items per page:&nbsp;&nbsp;&nbsp;
              {itemsPerPage.options?.map((link) => (
                <li
                  key={link}
                  className={clsx("page-item", {
                    active: itemsPerPage.limit === link,
                    disabled: isLoading,
                    previous: link === "&laquo; Previous",
                    next: link === "Next &raquo;",
                  })}
                >
                  <a
                    className="page-link"
                    onClick={() => updateItemsPerPage(link)}
                    dangerouslySetInnerHTML={{ __html: link }}
                    style={{ cursor: "pointer" }}
                  />
                </li>
              ))}
            </section> */}
            <ReactPaginate
              breakLabel={<div style={{ marginTop: 10 }}>...</div>}
              onPageChange={({ selected }: any) => {

                  updatePage(+selected + 1);
              }}
              pageRangeDisplayed={2}
              // forcePage={page}
              initialPage={+page -1}
              pageCount={pagination.links?.length}
              nextLabel=">"
              previousLabel="<"
              className={"pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              activeLinkClassName={"page-link active"}
              activeClassName={"page-item active"}
            />
          </ul>
        </div>
      </div>
    </div>
  );
};

export { UsersListPagination };
